'use client';

import { useKlimaMenu } from '@/app/(campaign)/wirfuersklima/KlimaMenuContext';
import { getCampaignHeaderMenuFromBlok } from '@/helper/campaign/campaignHeaderMenu';
import type { HeaderStoryblok } from '@/storyblok/wirfuersklima/types';
import { type SbBlokData, storyblokEditable } from '@storyblok/react/rsc';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import classNames from 'classnames';
import { useEffect } from 'react';

import Logo from '../logo/Logo';
import Navigation from '../navigation/Navigation';
import NavigationToggle from '../navigationToggle/NavigationToggle';
import classes from './Header.module.scss';

/** One campaign page, one main menu: stable id for aria-controls and scroll lock */
export const WIRFUER_KLIMA_NAV_ID = 'wirfuer-klima-nav';

export interface NavigationToggleType {
  toggleNavigation: () => void;
  isActive: boolean;
}

const Header: React.FC<{ blok: HeaderStoryblok }> = ({ blok }) => {
  const { isOpen, toggle } = useKlimaMenu();
  const menuItems = getCampaignHeaderMenuFromBlok(blok as unknown as Record<string, unknown>);

  // Full-screen <nav> lives in the header: lock scroll to that element (same as legacy)
  useEffect((): (() => void) | void => {
    const nav = document.getElementById(WIRFUER_KLIMA_NAV_ID) as HTMLElement | null;
    if (!nav) return;
    if (isOpen) {
      disableBodyScroll(nav);
    } else {
      enableBodyScroll(nav);
    }
    return () => {
      enableBodyScroll(nav);
    };
  }, [isOpen]);

  return (
    <header
      className={classNames(classes['header'], isOpen && classes['header--nav-open'])}
      {...storyblokEditable(blok as SbBlokData)}
    >
      <div className={classes['header__wrapper']}>
        {blok?.logo && <Logo image={blok.logo} />}
        <NavigationToggle controlsId={WIRFUER_KLIMA_NAV_ID} isActive={isOpen} toggleNavigation={toggle} />
      </div>
      <Navigation id={WIRFUER_KLIMA_NAV_ID} isActive={isOpen} navigation={menuItems} toggleNavigation={toggle} />
    </header>
  );
};

export default Header;
